import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateDefectListAsDeleted = async (
  projectId,
  defectListId
) => {
  const apiPath = `defect-lists/project/${projectId}/defect-list/${defectListId}/update-as-deleted`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
  });
  const response = await axios(signedRequest);

  return response.data;
};
